import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-email-confirmado',
  templateUrl: 'email-confirmado.component.html',
  styleUrls: ['email-confirmado.component.scss']
})
export class EmailConfirmadoComponent implements OnInit {
  public email = '';

  constructor(
    public route?: ActivatedRoute
  ) { }

  ngOnInit() {
    this.email = this.route.snapshot.params['email'] ? this.route.snapshot.params['email'] : '';
  }
}
